import { getQueryParameter, removeQueryParameter, setQueryParameter } from "@modules/util/query-parameter"

export function getSearchText() {
    return getQueryParameter("suchtext") || ""
}

export function setSearchText(value: string) {
    value === "" ? removeQueryParameter("suchtext") : setQueryParameter("suchtext", value)
}
